import navigationConstants    from './navigation.constants';
import navigationInitialState from './navigation.state';

function navigationReducer(state = navigationInitialState, action) {
  switch (action.type) {
    case navigationConstants.NAV_SET_BEHAVIOR:
      state = {
        ...state,
        behavior: action.behavior,
      };
      break;

    case navigationConstants.NAV_EXPAND_SECTION:
      state = {
        ...state,
        expand: [...action.ids],
      };

      break;

    case navigationConstants.NAV_TOGGLE_STATE:
      state = {
        ...state,
        open: action.open,
      };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default navigationReducer;